import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';
import { categories } from '@/mocks/categories';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-600 text-background-50 flex items-center justify-center font-heading font-bold text-lg">
                17
              </span>
              <span className="font-heading font-bold text-lg text-background-50">{siteConfig.name}</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/80">{siteConfig.description}</p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-8 h-8 rounded-md bg-background-50/10 flex items-center justify-center">
                <i className="ri-mail-line text-background-100"></i>
              </span>
              <div className="text-sm">
                <span className="block text-background-300/70 text-xs">投稿邮箱</span>
                <span className="text-background-100">{siteConfig.email}</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-base">内容栏目</h4>
            <ul className="space-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="text-sm text-background-200/80 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-base">关于与帮助</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-200/80 hover:text-primary-300 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-background-200/80 hover:text-primary-300 transition-colors cursor-pointer">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-background-200/80 hover:text-primary-300 transition-colors cursor-pointer">
                  我要爆料
                </Link>
              </li>
              <li>
                <Link to="/#tracking" className="text-sm text-background-200/80 hover:text-primary-300 transition-colors cursor-pointer">
                  独家追踪
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-base">内容原则</h4>
            <ul className="space-y-2.5 text-sm text-background-200/80">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-primary-300 mt-0.5"></i>
                多方信源交叉比对后再整理
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-primary-300 mt-0.5"></i>
                对非公开当事人做匿名处理
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-primary-300 mt-0.5"></i>
                明确标注核实状态与更新时间
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300/70">
            © {year} {siteConfig.name} · 本站内容为线索整理与资讯梳理，仅供交流参考。
          </p>
          <p className="text-xs text-background-300/70">最近更新：{siteConfig.updatedAt}</p>
        </div>
      </div>
    </footer>
  );
}